import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./unsecure-view-documents.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./unsecure-view-documents.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../shared/services/route-params.service";
import { AlertType } from "../../shared/models/alert";
import { APP_BASE_HREF } from "@angular/common";
import { UnsecureViewDocumentsService } from "./service/unsecure-view-documents.service";
import { AppConfig } from "../../app.config";
import { AppControllerService } from "../../app-controller.service";
import { CRUDOperation } from "../../shared/models/crud-operation-enum.model";
import { AppRoutingConstants } from "../../app-routing.constants";
import { DashboardRoutingConstants } from "../../core/dashboard/dashboard-routing.constants";
import { NavConstants } from "../../core/nav/nav.constants";
import { SaLongDatePipe } from "../../shared/pipes/sa-long-date/sa-long-date.pipe";
import { UnsecureViewDocumentsConstants } from "./unsecure-view-documents.constants";
import { FileUtils } from "src/app/shared/utils/file-utils";
let UnsecureViewDocumentsComponent = class UnsecureViewDocumentsComponent {
    baseHref;
    route;
    saLongDatePipe;
    appControllerService;
    unsecureViewDocumentsService;
    changeDetector;
    routerParamsService;
    appConfig;
    modulesLink = AppRoutingConstants.ROUTE_SEPERATOR + DashboardRoutingConstants.MODULES_ROUTE;
    homeLinkText = NavConstants.HOME_LINK_TEXT;
    titleLbl = UnsecureViewDocumentsConstants.TITLE;
    requestId;
    showBusyIndicator = true;
    dataSource;
    uniqueAttachmentTypes = [];
    noItemsMessage = UnsecureViewDocumentsConstants.NO_ITEMS_MESSAGE;
    firstOpenMessage = UnsecureViewDocumentsConstants.FIRST_OPEN_MESSAGE;
    commentExpiredMessage = UnsecureViewDocumentsConstants.CAPTURE_NOT_ALLOWED;
    noRequestIdMessage = UnsecureViewDocumentsConstants.NO_REQUESTID_MESSAGE;
    commentStatusClosed = UnsecureViewDocumentsConstants.COMMENT_STATUS_CLOSED;
    settingsSubscription;
    constructor(baseHref, route, saLongDatePipe, appControllerService, unsecureViewDocumentsService, changeDetector, routerParamsService, appConfig) {
        this.baseHref = baseHref;
        this.route = route;
        this.saLongDatePipe = saLongDatePipe;
        this.appControllerService = appControllerService;
        this.unsecureViewDocumentsService = unsecureViewDocumentsService;
        this.changeDetector = changeDetector;
        this.routerParamsService = routerParamsService;
        this.appConfig = appConfig;
        this.settingsSubscription = this.appConfig.$settings.subscribe(settings => {
            if (settings !== null) {
                AppConfig.settings = settings;
                this.logoSrc = AppConfig.settings.municipalData.aflalogo;
                this.appTitle = AppConfig.settings.projectSettings.projectName;
            }
        });
    }
    handleRouteChange() {
    }
    loadAppConfig(appConfigLoadedAction) {
        this.appConfig.load().then(() => {
            appConfigLoadedAction();
        });
    }
    ngOnInit() {
        this.loadAppConfig(() => {
            this.paramsSubscription = this.routerParamsService.params.subscribe(params => {
                this.requestId = params['requestId'];
            });
            if (!this.requestId) {
                this.showBusyIndicator = false;
                this.appControllerService.showMessage(this.noRequestIdMessage, AlertType.Warning);
                return;
            }
            this.UpdateStatus();
        });
    }
    getRequestData() {
        if (!this.requestId) {
            this.showBusyIndicator = false;
            this.appControllerService.showMessage(this.noRequestIdMessage, AlertType.Warning);
            return;
        }
        const params = {
            $expand: "Attachments",
            $filter: `requestGuid eq ${this.requestId}`
        };
        this.getViewDocumentsObservableSubscription = this.unsecureViewDocumentsService.getViewDocumentsObservable(params).subscribe({
            next: (returnValue) => {
                this.requestData = returnValue.value[0];
                if (this.requestData) {
                    if (this.requestData.expiryDate) {
                        const expiryDate = new Date(this.requestData.expiryDate);
                        const now = new Date();
                        if (expiryDate > now) {
                            if (this.requestData.firstOpenedDate) {
                                const firstOpenedDate = new Date(this.requestData.firstOpenedDate);
                                firstOpenedDate.setDate(firstOpenedDate.getDate() + 1);
                                if (this.requestData.status == this.commentStatusClosed && now < firstOpenedDate) {
                                    this.uniqueAttachmentTypes = [...new Set(this.requestData.attachments.map(obj => obj.attachmentType))];
                                    this.dataSource = this.requestData.attachments;
                                    this.appControllerService.showMessage(this.firstOpenMessage, AlertType.Warning);
                                }
                                else {
                                    this.appControllerService.showMessage(this.commentExpiredMessage, AlertType.Warning);
                                }
                            }
                        }
                        else {
                            this.appControllerService.showMessage(this.commentExpiredMessage, AlertType.Warning);
                        }
                    }
                    else {
                        this.showBusyIndicator = false;
                        this.changeDetector.detectChanges();
                        this.appControllerService.showMessage(this.commentExpiredMessage, AlertType.Warning);
                    }
                }
                this.showBusyIndicator = false;
                this.changeDetector.detectChanges();
            },
            error: (error => {
                this.appControllerService.handleServerErrorMessage(UnsecureViewDocumentsConstants.COMPONENT_TYPE, error, CRUDOperation.Get);
                this.showBusyIndicator = false;
            })
        });
    }
    UpdateStatus() {
        const updateParams = {
            requestGuid: this.requestId,
            status: "Closed"
        };
        this.updateDocumentRequestStatusSubscription = this.unsecureViewDocumentsService.updateDocumentRequestStatus(updateParams).subscribe({
            next: (result) => {
                this.getRequestData();
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(UnsecureViewDocumentsConstants.COMPONENT_TYPE, error, CRUDOperation.Get);
            }
        });
    }
    downloadFile(attachmentId, fileName) {
        this.getAttachmentContentObservableSubscription = this.unsecureViewDocumentsService.getAttachmentContentObservable(attachmentId)
            .subscribe({
            next: (response) => {
                FileUtils.openFile(fileName, response);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(UnsecureViewDocumentsConstants.COMPONENT_TYPE, error, CRUDOperation.Get);
            }
        });
    }
    goBackToModules() {
        this.menuMode = "modules";
        this.displayOrgSettings = false;
    }
    filterAttachmentType(file, type) {
        if (file.attachmentType == type) {
            return file;
        }
    }
    static ctorParameters = () => [
        { type: String, decorators: [{ type: Inject, args: [APP_BASE_HREF,] }] },
        { type: ActivatedRoute },
        { type: SaLongDatePipe },
        { type: AppControllerService },
        { type: UnsecureViewDocumentsService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService },
        { type: AppConfig }
    ];
};
UnsecureViewDocumentsComponent = __decorate([
    Component({
        selector: 'app-unsecure-view-documents',
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], UnsecureViewDocumentsComponent);
export { UnsecureViewDocumentsComponent };
